export default __webpack_public_path__ + "static/media/icons8-typescript.8af36283.svg";